module.exports = __webpack_public_path__ + "static/media/boat.7d7152da.jpg";